// src/pages/LoginPage.js
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLocale } from '../contexts/LocaleContext';
import { useNotification } from '../contexts/NotificationContext';
import { mapErrorKey } from '../utils/errorMapping';
import { Button } from 'baseui/button';
import { Input } from 'baseui/input';
import { FormControl } from 'baseui/form-control';
import { HeadingLarge } from 'baseui/typography';
import {
  PageContainer,
  SectionContainer,
  FlexColumnCentered
} from '../styles/controllerPageStyles';
import {
  ErrorMessage,
  AuthButtonContainer,
  AuthLinkContainer
} from '../styles/authPageStyles';
import PageFooter from '../components/common/PageFooter';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { t } = useLocale();
  const { showNotification } = useNotification();
  const navigate = useNavigate();

  // useSocket のロジックはSupabase認証では不要になるため削除
  // useEffect(() => {
  //   connectSocket();
  // }, [connectSocket]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!connected) {
    //   setError(t('errors.socketNotConnected'));
    //   return;
    // }
    setError('');
    setLoading(true);
    try {
      await login(email, password); // socket 引数を削除
      navigate('/dashboard');
    } catch (err) {
      const errorKey = err.message || 'UNKNOWN_ERROR';
      const clientKey = errorKey.startsWith('errors.') ? errorKey : mapErrorKey(errorKey);
      setError(t(clientKey));
      showNotification(t(clientKey), 'error');
    }
    setLoading(false);
  };

  return (
    <PageContainer>
      <FlexColumnCentered>
        <HeadingLarge>{t('pages.login.title')}</HeadingLarge>
      </FlexColumnCentered>
      <SectionContainer>
        <form onSubmit={handleSubmit}>
          <FormControl label={() => t('common.emailLabel')}>
            <Input
              id="email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </FormControl>
          <FormControl label={() => t('common.passwordLabel')}>
            <Input
              id="password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </FormControl>
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <AuthButtonContainer>
            <Button type="submit" isLoading={loading}>
              {t('pages.login.button')}
            </Button>
          </AuthButtonContainer>
        </form>
        <AuthLinkContainer>
          {t('pages.login.dontHaveAccount')}
          {' '}
          <Button onClick={() => navigate('/signup')} kind="tertiary" size="compact">
            {t('common.signUpButton')}
          </Button>
        </AuthLinkContainer>
        <AuthLinkContainer>
          <Button onClick={() => navigate('/manual')} kind="minimal" size="compact">
            {t('common.howToUse')}
          </Button>
          <Button onClick={() => navigate('/forgot-password')} kind="minimal" size="compact">
            {t('pages.login.forgotPassword')}
          </Button>
        </AuthLinkContainer>
      </SectionContainer>
      <PageFooter />
    </PageContainer>
  );
};

export default LoginPage;
